import React, { useState, useEffect } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
import "./index.scss";
import { useNavigate, useLocation } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";

const BusinessPartnerInputs = [
  {
    name: "bp_name",
    label: "Business Partner Name",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "bp_type",
    label: "Business Partner Type",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "contact_no",
    label: "Mobile No",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
    validation: { 
      required: true, pattern: /^[6-9]/ ,
      minLength:10,
      maxLength:10,
      message1: "Contact no should start with 6, 7, 8, 9",
      message: "Please enter a valid 10-digit",
    }
  },
  {
    name: "email_id",
    label: "Email Address",
    type: "email",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "contactNo",
    label: "Contact No",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
    validation: { 
      required: true, pattern: /^[6-9]/ ,
      minLength:10,
      maxLength:10,
      message1: "Contact no should start with 6, 7, 8, 9",
      message: "Please enter a valid 10-digit",
    }
  },
  {
    name: "pincode",
    label: "Pincode",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "city_id",
    label: "City Id",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "state_id",
    label: "State Id",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "country_id",
    label: "Country Id",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "bp_address",
    label: "Address",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "gst_no",
    label: "Gst No.",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "max_hierarchy_level",
    label: "Max Hierarchy Level	",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "onboard_process_type",
    label: "Onboard Process Type",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "status",
    label: "Status",
    type: "multiselectdropdown",
    required: true,
    options: [
      { label: "Active", value: "Active" },
      { label: "Inactive", value: "Inactive" },
    ],
    gridClass: "col-lg-4",
  },
  // {
  //   name: "description",
  //   label: "Description",
  //   type: "richeditor",
  //   gridClass: "col-lg-12",
  // }
 
];

const AddNewBusinessPartner = () => {
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { rowData } = location.state || {};

  useEffect(() => {
    if (rowData) {
      const transformedData = { ...rowData };

      // Transform status field to match Select component's expected format
      if (rowData.status) {
        transformedData.status = [{ label: rowData.status, value: rowData.status }];
      }

      setFormData(transformedData);
    }
  }, [rowData]);

  // const handleFormSubmit = (data) => {
  //   setIsFormSubmitted(true);
  //   console.log("Form Data:", data);
  //   // Navigate to another route after form submission
  //   navigate(ROUTES_NAVIGATION.BUSINESSPARTNERDETAILS);
  // };

  const authToken = localStorage.getItem("authToken");

  const handleFormSubmit = async (formData) => {
    console.log("formData",formData);
    try {
      const response = await axiosInstance.post('/bp-onboard/create', {
        // business_partner_id:1,
        onboard_process_type:formData.onboard_process_type,
        // max_hierarchy_level:formData.max_hierarchy_level,
        bp_type: formData.bp_type,
        bp_name:formData.bp_name,
        contact_no:formData.contact_no,
        email_id:formData.email_id,
        pincode:formData.pincode,
        city_id:formData.city_id,
        state_id:formData.state_id,
        country_id:formData.country_id,
        bp_address:formData.bp_address,
        gst_no:formData.gst_no,
        status: formData.status.value="Active"?1:0, 
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      }
    );
  
      console.log("Unit added successfully:", response.data);
      navigate("/admin/manage-dealer/business-partner"); 
    } catch (error) {
      console.error('Error adding unit:', error);
     
    }
  };

  return (
    <>
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Add New Business Partner</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Business Partner Details
        </span>
        <DynamicForm
          formConfig={BusinessPartnerInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            if (!isFormSubmitted) {
              handleFormSubmit(formData); // Call handleFormSubmit if isFormSubmitted is false
            }
          }}
          className="submit-btn"
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default AddNewBusinessPartner;
